<div class="ya-typography" (swiperight)="SwiperNavigateBack()">
  <ya-subheader [hasContent]="true" [disableNavigateBack]="true" (onNavigateBackClick)="navigateBack()">

  </ya-subheader>
  <div [@serviceButtonEntering]="isLoaded"
    class="ya-page-content ya-page-content--webshop ya-page-content--inset ya-page-content--aligncenter">
    <div class="description">
      <h2 langkey="phVoucherCredit_Page_Title"></h2>
      <p langkey="phVoucherCredit_Page_Description"></p>
    </div>
    <div class="menu-service-item-container">
      <ng-container *ngIf="isLoaded">
        <div a11y_Button class="ya-icon-button service-button" (click)="checkService(voucherServiceType.Charge)">
          <div class="icon-container">
            <div class="inline-icon" inlineSVG="shop-icons.svg#ya-hypersoft-user-single"></div>
          </div>
          <div class="content-container">
            <h2 class="title" langkey="phVoucherCredit_Credit_Title"></h2>
            <div class="text content-container--subfont" langkey="phVoucherCredit_Credit_Description"></div>
          </div>
        </div>
        <div a11y_Button class="ya-icon-button service-button" (click)="checkService(voucherServiceType.Order)">
          <div class="icon-container">
            <div class="inline-icon" inlineSVG="shop-icons.svg#ya-hypersoft-gutschein"></div>
          </div>
          <div class="content-container">
            <h2 class="title" langkey="phVoucherCredit_Voucher_Title"></h2>
            <div class="text content-container--subfont" langkey="phVoucherCredit_Voucher_Description"></div>
          </div>
        </div>
      </ng-container>
    </div>
  </div>
</div>